import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { LocationService } from 'src/app/shared/location.service';
import { Global } from 'src/app/Global';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import saveAs from 'file-saver';
import { LocationMasterComponent } from '../location-master/location-master.component';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';


@Component({
  selector: 'app-location-master-view',
  templateUrl: './location-master-view.component.html',
  styleUrls: ['./location-master-view.component.css'],
  // standalone:true,
  // imports:[DropdownModule,ReactiveFormsModule,FormsModule
  //   ,MatPaginatorModule,MatTableModule,CommonModule,]
})
export class LocationMasterViewComponent implements OnInit {

  /***********************************Declare Private Properties************************/
  LocationRecordsForm: UntypedFormGroup;
  isLoadingResults = false;
  locationList: any;
  displayedColumns = ['Location', 'SPOCName', 'Email','PhoneNo'];

  LocationDataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort,{ static: true }) sort: MatSort;
  /******************************************END***************************************/

  constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
    public _commonService: CommonService, private error: AppErrorHandler,
    private _locationService: LocationService, injector: Injector,private _dialog: MatDialog,
    private status: HTTPStatus) { }

  ngOnInit() {

    this.paginator.showFirstLastButtons = true;
    this.paginator.pageSize = this._global.RecordSize;

    this.LocationRecordsForm = this._fb.group({
      LocationName: [],
      LocationHead: [],
      LocationID:[],
      PageNumber: (this._global.pageIndex)
    });
    this.BindLocationList();
    this.SearchRecord();
  }
  BindLocationList() {
    this._commonService.BindDropDown('location').subscribe(result => {
      this.locationList = result;
    });
  }

  SearchRecord() {
    
    this._global.pageIndex = 1;
    this._global.length = 0;
    this._global.totalPage = 0;
    //this.LoadAllLocationMasterList();
  }

  openLocationMasterDialog() {
  
    this._dialog.open(LocationMasterComponent,
      {
        width: '1250px',
        height:'600px',
        disableClose: true
      });
  }

  LoadAllLocationMasterList() {
    this.status.setHttpStatus(true);
    this.LocationRecordsForm.controls.PageNumber.setValue(this._global.pageIndex - 1);
    this._locationService.GetAllLocationMasterList(this.LocationRecordsForm.value).subscribe(data => {
      if (data.RequestData != null && data.RequestData.length > 0) {        
        this.LocationDataSource = new MatTableDataSource(data.RequestData);
        if (this._global.length === 0) {
          this._global.length = data.TotalRecordCount;
          this.LocationDataSource.paginator = this.paginator;
          this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
          this.LocationDataSource.sort = this.sort;
        } else {
          this.paginator.pageIndex = this._global.pageIndex - 1;
          this.status.setHttpStatus(false);
        }
      } else {
        this.LocationDataSource = new MatTableDataSource(data.RequestData);
        this._global.length = data.TotalRecordCount;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 1;
        this._global.totalPage = 0;
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {  this.status.setHttpStatus(false); });
  }

  ShowDetails(row: any) {
  
    this._router.navigate(['admin/add-location', row.RequestEntityId]);
  }

  Reset() {
    this.LocationRecordsForm.reset();
  }

  // ******************************************Pagging*************************************//
  onPaginateChange(e: any) {
    this._global.pageIndex = (e.pageIndex + 1);
    this.LoadAllLocationMasterList();
  }


  GoToPage() {
    if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
      (this._global.pageIndex > this._global.totalPage) {
      this._global.pageIndex = this._global.totalPage;
    }
    this.LoadAllLocationMasterList();
  }

  Export() {
  
    this._locationService.ExportData(this.LocationRecordsForm.value).subscribe(x => {
        const blob = new Blob([x], { type: 'application/octet-stream' });
        saveAs(blob, 'LocationDetails.xls');
    });
  }

  // **************************************Pagging End*************************************//

}
